import type { HTMLAttributes } from "react";
import type { SpaceProps } from "styled-system";

type ProgressTypes = HTMLAttributes<HTMLDivElement>;

// Colors
export enum progressColor {
  PRIMARY_500 = "PRIMARY_500",
  SPECIAL_500 = "SPECIAL_500",
  ERROR_500 = "ERROR_500",
  WARRING_500 = "WARRING_500",
  GRAYSCALE_400 = "GRAYSCALE_400",
}

export const progressColors = Object.freeze({ ...progressColor });
export type ProgressColor =
  (typeof progressColors)[keyof typeof progressColors];

export type ProgressProps = {
  color?: ProgressColor;
  typeButton?: boolean;
  micro?: boolean;
} & ProgressTypes &
  SpaceProps;
